import './IconPause2.css';
import React from 'react';
const IconHeart = _ref => {
  let {
    width = 18,
    height = 22,
    className = ''
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    className: `${className} ${styles}`,
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 18 22"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M1 0a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1zm8 0a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1z",
    transform: "translate(4 2)"
  }));
};
const styles = "s1t4r9dr";
export default IconHeart;